/* Nouraé Beauty — brand behaviour layer */
(function () {
  'use strict';

  var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- reveal on scroll ---------- */
  function boot(root) {
    root = root || document;
    var items = root.querySelectorAll('.nr-rise:not([data-nr-seen])');
    if (!items.length) return;
    if (reduced || !('IntersectionObserver' in window)) {
      items.forEach(function (el) { el.setAttribute('data-nr-seen', '1'); el.classList.add('is-in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-in');
        io.unobserve(entry.target);
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    items.forEach(function (el) { el.setAttribute('data-nr-seen', '1'); io.observe(el); });
  }

  /* ---------- cash on delivery only ----------
     The EasySell form replaces the cart entirely, so any cart control the
     theme renders is taken out of the customer's path. Matching by
     accessible name rather than class keeps this working across theme
     updates that rename things.                                        */
  function hideCartControls() {
    var header = document.getElementById('header-component');
    if (!header) return;
    header.querySelectorAll('a, button').forEach(function (el) {
      if (el.hasAttribute('data-nr-cart-hidden')) return;
      var href = (el.getAttribute('href') || '').toLowerCase();
      var label = ((el.getAttribute('aria-label') || '') + ' ' + (el.textContent || '')).toLowerCase().trim();
      var isCart = href.indexOf('/cart') !== -1 || /(^|[^a-z])cart([^a-z]|$)/.test(label);
      if (!isCart) return;
      el.setAttribute('data-nr-cart-hidden', '1');
      var target = el;
      // Walk up while the parent exists only to hold this control.
      while (target.parentElement && target.parentElement !== header &&
             target.parentElement.children.length === 1) {
        target = target.parentElement;
      }
      target.style.display = 'none';
    });
  }

  /* ---------- order form reveal ----------
     The EasySell cash-on-delivery form renders inside the product form as
     #easysell. We lift it into a collapsed panel so the page opens with a
     single "Order now" button instead of a wall of input fields.        */
  var panelReady = false;

  function mountOrderPanel() {
    var panel = document.querySelector('[data-nr-orderpanel] .nr-orderpanel__inner');
    var form = document.querySelector('#easysell');
    if (!panel || !form) return false;
    if (form.getAttribute('data-nr-moved')) return true;
    panel.appendChild(form);
    form.setAttribute('data-nr-moved', '1');
    return true;
  }

  function openOrderPanel(scroll) {
    var wrap = document.querySelector('[data-nr-orderpanel]');
    if (!wrap) return;
    mountOrderPanel();
    wrap.classList.add('is-open');
    wrap.setAttribute('aria-hidden', 'false');
    document.querySelectorAll('[data-nr-open-order]').forEach(function (b) {
      b.setAttribute('aria-expanded', 'true');
      if (b.hasAttribute('data-nr-hide-after')) b.style.display = 'none';
    });
    if (scroll !== false) {
      window.setTimeout(function () {
        var target = document.getElementById('nr-order') || wrap;
        target.scrollIntoView({ behavior: reduced ? 'auto' : 'smooth', block: 'start' });
        var first = wrap.querySelector('input:not([type=hidden]), select, textarea');
        if (first) window.setTimeout(function () { try { first.focus({ preventScroll: true }); } catch (e) {} }, 520);
      }, 60);
    }
  }

  function initOrder() {
    var wrap = document.querySelector('[data-nr-orderpanel]');
    if (!wrap) return;

    if (!panelReady) {
      panelReady = true;
      var tries = 0;
      var poll = window.setInterval(function () {
        tries++;
        if (mountOrderPanel() || tries > 80) window.clearInterval(poll);
      }, 250);
    }

    document.querySelectorAll('[data-nr-open-order]:not([data-nr-bound])').forEach(function (btn) {
      btn.setAttribute('data-nr-bound', '1');
      btn.setAttribute('aria-expanded', 'false');
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        openOrderPanel(true);
      });
    });
  }

  /* ---------- smooth scroll helpers ---------- */
  function initScrollers() {
    document.querySelectorAll('[data-nr-scroll]:not([data-nr-bound])').forEach(function (btn) {
      btn.setAttribute('data-nr-bound', '1');
      btn.addEventListener('click', function (e) {
        var sel = btn.getAttribute('data-nr-scroll') || '#nr-order';
        var target = document.querySelector(sel);
        if (!target) return;
        e.preventDefault();
        target.scrollIntoView({ behavior: reduced ? 'auto' : 'smooth', block: 'start' });
      });
    });
  }

  /* ---------- mobile order bar ---------- */
  function initOrderBar() {
    var bar = document.querySelector('[data-nr-orderbar]');
    if (!bar || bar.getAttribute('data-nr-bound')) return;
    bar.setAttribute('data-nr-bound', '1');
    var anchor = document.getElementById('nr-order');
    function update() {
      var show;
      if (anchor) {
        show = anchor.getBoundingClientRect().bottom < 40;
      } else {
        show = window.scrollY > 620;
      }
      bar.classList.toggle('is-visible', show);
    }
    window.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    update();
  }

  /* ---------- notification widget ---------- */
  function initPop() {
    var el = document.querySelector('[data-nr-pop]');
    if (!el || el.getAttribute('data-nr-bound')) return;
    el.setAttribute('data-nr-bound', '1');

    var items;
    try { items = JSON.parse(el.getAttribute('data-nr-pop') || '[]'); } catch (e) { items = []; }
    if (!items.length) { el.remove(); return; }

    var closed = false;
    var i = 0;
    var body = el.querySelector('[data-nr-pop-body]');
    var closeBtn = el.querySelector('.nr-pop__x');
    if (closeBtn) closeBtn.addEventListener('click', function () { closed = true; el.classList.remove('is-in'); });

    var firstDelay = parseInt(el.getAttribute('data-nr-pop-first') || '6000', 10);
    var showFor = parseInt(el.getAttribute('data-nr-pop-show') || '6000', 10);
    var gap = parseInt(el.getAttribute('data-nr-pop-gap') || '11000', 10);

    function cycle() {
      if (closed) return;
      var item = items[i % items.length];
      i++;
      if (body) {
        body.innerHTML = '<div class="nr-pop__t"></div><div class="nr-pop__s"></div>';
        body.querySelector('.nr-pop__t').textContent = item.title || '';
        body.querySelector('.nr-pop__s').textContent = item.sub || '';
      }
      el.classList.add('is-in');
      window.setTimeout(function () {
        if (closed) return;
        el.classList.remove('is-in');
        window.setTimeout(cycle, gap);
      }, showFor);
    }
    window.setTimeout(cycle, firstDelay);
  }

  /* ---------- contact form niceties ---------- */
  function initContact() {
    var form = document.querySelector('[data-nr-contact]:not([data-nr-bound])');
    if (!form) return;
    form.setAttribute('data-nr-bound', '1');
    form.addEventListener('submit', function () {
      var btn = form.querySelector('button[type=submit]');
      if (btn) { btn.disabled = true; btn.textContent = 'Sending…'; }
    });
  }

  function initAll(root) {
    boot(root);
    hideCartControls();
    initScrollers();
    initOrder();
    initOrderBar();
    initPop();
    initContact();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
  window.addEventListener('load', function () { initOrder(); hideCartControls(); });
})();
